// extracted by mini-css-extract-plugin
export var dropdownButton = "_3t-0";
export var fullWidthDropdownButton = "_3t-1";
export var icon = "_3t-3";
export var iconPlaceholder = "_3t-2";
export var menuItemRow = "_3t-5";
export var shortcutContainer = "_3t-4";